import getMonetateExperience from '../../app/utils/monetate/getMonetateExperience';

const moveL2CategoriesToEnd = features => originalCategories => {
  const data = getMonetateExperience(features, 'move-l2-categories');
  if (!data) return originalCategories;

  const { name = '' } = data.parameters || {};

  const L2Categories = name.split(',');

  return L2Categories.reduce((categories, l2Category) => {
    const [categoryName, categoryL2Heading] = l2Category.trim().split('|');

    if (!categoryName || !categoryL2Heading) return categories;

    const topLevelCategory = categories.child.find(
      c => c.name === categoryName
    );

    if (!topLevelCategory) return categories;

    const categoryToMove = topLevelCategory.child.find(
      c => c.name === categoryL2Heading
    );

    if (!categoryToMove) return categories;

    const level2Categories = topLevelCategory?.child.filter(
      c => c.name !== categoryL2Heading
    );

    const changedCategory = {
      ...topLevelCategory,
      child: [...level2Categories, categoryToMove],
    };

    return {
      ...categories,
      child: categories.child.map(currentCategory =>
        currentCategory.name === changedCategory.name
          ? changedCategory
          : currentCategory
      ),
    };
  }, originalCategories);
};

export const moveL2TopCategoriesToEnd = (features, topLevelCategory) => {
  const data = getMonetateExperience(features, 'move-l2-categories');
  if (!data) return topLevelCategory;
  const { name = '' } = data?.parameters || {};

  const L2Categories = name.split(',').map(x => x.trim());

  const l2Category = L2Categories.find(l2 =>
    l2.startsWith(`${topLevelCategory.name}|`)
  );

  if (!l2Category) return topLevelCategory;

  const [, categoryL2Heading] = l2Category.split('|');

  const categoryToMove = topLevelCategory.child.find(
    c => c.name === categoryL2Heading
  );

  if (!categoryToMove) return topLevelCategory;

  const level2Categories = topLevelCategory?.child.filter(
    c => c.name !== categoryL2Heading
  );

  return {
    ...topLevelCategory,
    child: [...level2Categories, categoryToMove],
  };
};

export default moveL2CategoriesToEnd;
